<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <!-- Keep-alive should wrap <router-view /> -->

    <div class="homepage d-flex flex-column vh-100">
      <!-- navbar -->
      <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
        <div class="d-flex align-items-center">

          <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;

          <span>
            <h4 class="text-white">{{ language?.Room_Bookings_details }}</h4>
          </span>


          <!-- <div class="d-flex align-items-center gap-2 ms-auto">
                
                 <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#branch"
                  aria-controls="branch">
                  <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
                  <i class="bi bi-plus  d-flex m-1 h4 text-white"></i>
                  </b>
                  </a>
               </div> -->
        </div>




      </div>

      <!-- body -->
      <div class="my-auto overflow-auto vh-100">

      <div class="card">
        <div class="card-body">

       <div class="col-12 row">
        <div class="col-4">
          <span>Room No:{{ get_room_booking_info.room_no }}</span> 
          </div>
           
            <div class="col-8">

               <span>Check - in:{{ get_room_booking_info.iddate }}</span> 
              </div>
              </div>

              <div class="col-12">
                        <div class="row fw-bold" v-for="(item, index) in get_cust_info" :key="index">
                          <span>
                            {{index+1}}) {{ item.cust_name }}
                            <span style="margin-left: 30px;">
                               <a :href="'tel:' + item.cust_contact">{{ item.cust_contact }}</a>
                            </span>
                            <span style="margin-left: 30px;">
                              / {{ item.cust_gender }}
                            </span>
                          </span>
                        </div>
                      </div>
<hr> 


                      <div class="col-12 row" >
                        <div class="col-6">
                      <span> Room Amount: <strong> {{  get_room_booking_info.totalamt}} </strong></span>
                      </div>
                       <div class="col-6">
                      <span>  Paid Amount: <strong>{{  get_room_booking_info.paidamt}} </strong></span>
                      </div>
                      </div>

                       <span> Service Amount: <strong> {{ totalPaid }} </strong></span><br>

                       <div class = "col-12 row">
                        <div class="col-6">

                      <span> Total Amount: <strong> {{ get_total.total_amt ?? 0 }} </strong></span>
                      </div>
                      <div class="col-6">

                      <span class="text-danger"> Due Amount: <strong> {{ get_due.due_amt ?? 0}} </strong></span>
                      </div>
                      </div>





            </div>
        </div>




        <div class="card">
            
             <div class="card-body p-1">
                <span ><strong>Add Service</strong></span>

                <div class="col-12">
                    <div class="row">
                     <div class="col-6">
                    <div class="">
                        <label for="mobile" class="service_name">{{ language?.Service_Name }}</label>
                        <input type="text" id="mobile" v-model="service.servicename" class="form-control" required>
                    </div>

                        </div>
                          <div class="col-3">
                   <div class="">
                        <label for="mobile" >{{ language?.Service_Cost }}</label>
                        <input type="text" id="mobile" v-model="service.cost" class="form-control" required>
                    </div>
                        </div>
                          <div class="col-3">
                            <div class="mt-3">
                           <button class="btn btn-primary btn-sm" @click="save_service()">Save</button>
                           </div>
                        </div>
                        </div>
                    </div>




             </div>

            </div>


          <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Service Name</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in get_service_list" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.servicename }}</td>
                          <td>{{ item.total }}</td>
                        </tr>
                      </tbody>
                       <tfoot>
                            <tr>
                              <td colspan="2" class="text-end"><strong>Total</strong></td>
                              <td><strong>{{ totalPaid }}</strong></td>
                            </tr>
                          </tfoot>
                    </table>

                        <button class="btn btn-danger btn-sm fixed-bottom" data-bs-toggle="offcanvas" data-bs-target="#orderDetailsCanvas">
                                  Check Out
                                </button>











      </div>

      <div class="offcanvas offcanvas-bottom custom_height border-0" tabindex="-1" id="orderDetailsCanvas"
        aria-labelledby="orderLabel">
        <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
          <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i
              class="bi bi-arrow-left fs-5 text-white"></i></a>
          <h6 class="offcanvas-title text-white m-0" id="orderLabel">{{language?.payment_details}}</h6>
        </div>
                <div class="offcanvas-body">
                  <div class="col-12 row">
                       <div class="col-6">
                      <span> Room Amount: <strong> {{  get_room_booking_info.totalamt}} </strong></span>
                      </div>
                       <div class="col-6">
                      <span>  Paid Amount: <strong>{{  get_room_booking_info.paidamt}} </strong></span>
                      </div>
                      </div>

                           <table class="table table-striped" v-if = "get_service_list.length > 0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Service Name</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in get_service_list" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.servicename }}</td>
                          <td>{{ item.total }}</td>
                        </tr>
                      </tbody>
                       <tfoot>
                            <tr>
                              <td colspan="2" class="text-end"><strong>Total</strong></td>
                              <td><strong>{{ totalPaid }}</strong></td>
                            </tr>
                          </tfoot>
                    </table>

                    <div class = "col-12 row">
                        <div class="col-6">

                      <span> <strong>Total Amount:  {{ get_total.total_amt }} </strong></span>
                      </div>
                      <div class="col-6">

                      <span class="text-danger"> <strong>Due Amount:  {{ get_due.due_amt }} </strong></span>
                      </div>
                      </div>
<hr> 
                      <div class="col-12 row">

              <div class="col-6">
                        <label for="address m-0 p-0" class="form-label ">{{language?.paid_amt}}</label>
                        <input type="number" id="" v-model="checkout.paid" class="form-control m-0 p-0" >
                    </div>

                      <div class="col-6 mt-2">
                        <label for="checkoutNote" class="form-label m-0 p-0 ">{{ language?.payment_type }}</label>
                        <select id="checkoutNote" v-model="checkout.paymenttype" class="form-control m-0 p-0" required>
                          <option value="">Select Payment Type</option>
                          <option value="Cash">Cash</option>
                          <option value="UPI">UPI</option>
                          <option value="Debit Card">Debit Card</option>
                           <option value="Credit Card">Credit Card</option>
                        </select>
                      </div>

                </div>

                        <div class="col-12">
                        <label for="address m-0 p-0" class="form-label">{{language?.note}}</label>
                        <input type="text" id="" v-model="checkout.note" class="form-control m-0 p-0" >
                    </div>

                     <div class="col-12">
                        <label for="address m-0 p-0" class="form-label">{{language?.check_out}}</label>
                        <input type="datetime-local" id="" v-model="checkout.checkoutdatetime" class="form-control m-0 p-0" >
                    </div>









                  </div>
         <div class="offcanvas-footer">
             <!--<button class="btn btn-success col-12" v-if="selected_services && selected_services.length>0" @click="confirmCosts">-->
             <button class="btn btn-success col-12"  @click="save_payment">
              <i class="bi bi-check"></i> &nbsp;{{language?.check_out}}
            </button>
         </div>
      </div>

    </div>
  </div>
</template>

<style>
.bg_card {
  background: #ededec;
  margin: 10px 0px;
  padding-bottom: 28px;
  padding: 10px;
}
.bg-light-red {
  background-color: #ffd8db; /* Light red color */
}
.service_name{
  font-size: 13px;
}

</style>

<script>
import axios from "@/plugins/axios";

export default {
  name: 'Branch',
  components: {
  },
  mounted() {
    //  this.fetchWeather();
    if (this.$route.query.q) {
         
            this.getBranches(this.$route.query.q);
            
           

        }
        else{
         
            this.getBranches();
        }
 // Call the method here

  },
  computed: {
  totalPaid() {
    return this.get_service_list.reduce((sum, item) => {
      return sum + Number(item.total || 0);
    }, 0);
  }
},

  data() {
    return {
      loading: false,
      error: null,
      isUserLogged: false,
      user_details: [],
      get_service_list:[],
      get_due:[],


      language: this.getLocalStorageArray('lang'),
      room: {
        roomno: '',
        roomtype: '',
        description: '',
        mrp: '',
        cost: '',
        capacity: '',
        status: '',
        catid: ''

      },
      checkout:{
        paid:'',
        note:'',
        paymenttype:'',
        bookingid:this.$route.query.q,
        checkoutdatetime:''
      },


   
      get_total:[],
      getallroom: [],
      roomcatlist: [],
      get_cust_info:[],
      get_room_booking_info: [],
      branch_name: '',
      service:{
        servicename:'',
        cost:'',
        bookingid:this.$route.query.q,
      }

    }
  },
  methods: {
    initializeHomeContent() {


    },
    goBack() {

      this.$router.go(-1);
    },
    goprevious() {

      this.$router.go("/branch");
    },



    async getBranches(id) {
      this.loading = true;
      this.error = null;

    

      try {
        var self = this;
        axios.post("get_Room_booking_details",{id:id}).then((response) => {
          self.get_room_booking_info = response.data.get_room_booking_info;
          self.get_cust_info = response.data.get_cust_info;
           self.get_service_list = response.data.get_service_list;
            self.get_total = response.data.get_total;
            self.get_due = response.data.get_due;
          self.language = response.data.language;
          localStorage.setItem('lang', response.data.language);

        }).then(() => {
          self.initializeHomeContent();
        }).catch((err) => {

        });;


      } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },





    addBranch() {
      this.loading = true;
      this.error = null;

      try {
        var self = this;
        axios.post("addroom", self.room).then((response) => {

          self.getallroom = response.data.getallroom;
          self.language = response.data.language;
          self.$swal.fire(response.data.message);
          if (response.data.success) {
            self.branch = { name: '', address: '', contact: '', };
          }
          window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();




        }).then(() => {
          self.initializeHomeContent();
        }).catch((err) => {

        });;


      } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },


    editBranch(editBranch) {
      window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
      this.room = editBranch;
    },





    deleteBranch(id = "") {
      this.loading = true;
      this.error = null;

      try {
        var self = this;

        this.$swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post("delete_room", { id: id }).then((response) => {
              self.getallroom = response.data.getallroom;
              self.language = response.data.language;
              self.$swal.fire(response.data.message);

              if (response.data.success) {
                window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
              }
            }).then(() => {
              self.initializeHomeContent();
            }).catch((err) => {
              self.$swal.fire("Error!", "Something went wrong.", "error");
            });
          }
        });

      } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    getLocalStorageArray(key) {
      let data = localStorage?.getItem(key);
      try {
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error("Error parsing localStorage data", e);
        return [];
      }
    },






        async save_service() {
                this.loading = true;
                this.error = null;

             

                try {
                    var self = this;
                    axios.post("save_services",self.service).then((response) => {
                    self.get_room_booking_info = response.data.get_room_booking_info;
                    self.get_cust_info = response.data.get_cust_info;
                    self.get_service_list = response.data.get_service_list;
                    self.get_total = response.data.get_total;
                    self.get_due = response.data.get_due;
                    self.language = response.data.language;
   
                     self.$swal.fire(response.data.message);
                     
                         self.service={
                                servicename:'',
                                cost:'',
                              
                            }

                    }).then(() => {
                    self.initializeHomeContent();
                    }).catch((err) => {

                    });;


                } catch (err) {
                    this.error = err.response?.data?.message || "Login failed. Please try again.";
                } finally {
                    this.loading = false;
                }
                },






                    async save_payment(id) {
      this.loading = true;
      this.error = null;

    

      try {
        var self = this;
        axios.post("save_payment",self.checkout).then((response) => {
          // self.get_room_booking_info = response.data.get_room_booking_info;
          // self.get_cust_info = response.data.get_cust_info;
          //  self.get_service_list = response.data.get_service_list;
          //   self.get_total = response.data.get_total;
          //   self.get_due = response.data.get_due;
          // self.language = response.data.language;
          //  self.$swal.fire(response.data.message);
             window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("orderDetailsCanvas")).hide();
            var bookingid=   response.data.bookingid;
            self.$router.push('/orderDetails?id='+bookingid); 
         

        }).then(() => {
          self.initializeHomeContent();
        }).catch((err) => {

        });;


      } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },

          



















  }
}






</script>
